import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../../../../axios';
import { AppThunk } from '../../../../../store';
import { TurbineStatus } from '../../../../Shared/Landing/Landing.slice';
import { ToastAnt } from '../../../../Shared/Toast/ToastAnt';
import { checkTurbineInfo } from '../../annotation.slice';
import { SelectOption } from '../../annotation.types';

export type TurbineStatusInfo = {
  status: TurbineStatus;
  statusString: string;
  userId?: string;
  possibleNextStatuses: SelectOption[];
  canChangeStatus: boolean;
};

type State = {
  turbineStatusInfo: TurbineStatusInfo | null;
  updatingStatus: boolean;
};

const initialState: State = {
  turbineStatusInfo: null,
  updatingStatus: false
};

const turbineStatusSlice = createSlice({
  name: 'qc',
  initialState,
  reducers: {
    setStatusUpdating(state, action: PayloadAction<boolean>) {
      state.updatingStatus = action.payload;
    },
    setTurbineStatusInfo(state, action: PayloadAction<TurbineStatusInfo>) {
      state.turbineStatusInfo = action.payload;
    }
  }
});

export const { setStatusUpdating, setTurbineStatusInfo } = turbineStatusSlice.actions;

export default turbineStatusSlice.reducer;

export const getCurrentAndPossibleTurbineStatuses =
  (turbinePath: string): AppThunk =>
  async dispatch => {
    try {
      dispatch(setStatusUpdating(true));
      const url = `turbine/possibleStatuses/${turbinePath}`;
      const response = await axios.get<TurbineStatusInfo>(url);
      dispatch(setTurbineStatusInfo(response.data));
      dispatch(setStatusUpdating(false));
    } catch (error) {
      ToastAnt('An error occured.');
    }
  };

export const updateTurbineStatus =
  (turbinePath: string, turbineStatus: TurbineStatus): AppThunk =>
  async dispatch => {
    try {
      dispatch(setStatusUpdating(true));
      const url = `turbine/updatestatus/${turbinePath}/${turbineStatus}`;
      const response = await axios.post(url);
      dispatch(getCurrentAndPossibleTurbineStatuses(turbinePath));
      dispatch(setStatusUpdating(false));
      dispatch(checkTurbineInfo(turbinePath));
      ToastAnt('Updated.');
    } catch (error) {
      ToastAnt('An error occured.');
    }
  };
